import React, { useState, useEffect } from 'react';
import axios from 'axios';
import SimpleDialog from '../../../../features/common/SimpleDialog';
import SectionAppBar from '../../../components/Section/SectionAppBar';
import CloseButton from '../../../components/Button/CloseButton';
import StandardButton from '../../../components/Button/StandardButton';
import KeyIcon from '@mui/icons-material/Key';
import KeyOffIcon from '@mui/icons-material/KeyOff';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Box from '@mui/material/Box';

const ApiKeyManager = () => {
    const [apiKey, setApiKey] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        // Fetch the API key on component load
        getApiKey();
    }, []);

    const getApiKey = async () => {
        try {
            setError('');
            setLoading(true);
            const response = await axios.get('/api/UserApiKey/get');
            setApiKey(response.data.apiKey);
            setLoading(false);
        } catch (err) {
            setError('Failed to load API key.');
            setLoading(false);
        }
    };

    const generateApiKey = async () => {
        try {
            setError('');
            setLoading(true);
            const response = await axios.post('/api/UserApiKey/generate');
            setApiKey(response.data.apiKey);
            setLoading(false);
        } catch (err) {
            setError('Failed to generate API key.');
            setLoading(false);
        }
    };

    const revokeApiKey = async () => {
        try {
            setError('');
            setLoading(true);
            await axios.delete('/api/UserApiKey/revoke');
            setApiKey('');
            setLoading(false);
        } catch (err) {
            setError('Failed to revoke API key.');
            setLoading(false);
        }
    };

    const copyToClipboard = () => {
        navigator.clipboard.writeText(apiKey);
        alert('API Key copied to clipboard!');
    };

    return (
        <>
            <StandardButton icon={<KeyIcon />} onClick={() => setOpen(true)}>
                Manage API Keys
            </StandardButton>

            <SimpleDialog
                open={open}
                fullHeight={false}
                size="sm"
                padding={0}
                onClose={() => {
                    setOpen(false);
                }}
            >
                <SectionAppBar
                    title="Manage API Key"
                    subTitle=""
                    buttons={
                        <>
                            {apiKey ? (
                                <StandardButton onClick={revokeApiKey} icon={<KeyOffIcon />}>
                                    Revoke API Key
                                </StandardButton>
                            ) : (
                                <StandardButton onClick={generateApiKey} icon={<KeyIcon />}>
                                    Generate API Key
                                </StandardButton>
                            )}

                            <CloseButton onClick={() => setOpen(false)}>Close</CloseButton>
                        </>
                    }
                />
                <Box padding={2}>
                    {loading ? (
                        <p>Loading...</p>
                    ) : (
                        <>
                            {apiKey ? (
                                <>
                                    <Box display="flex" alignItems="center">
                                        <p>Your API Key: {apiKey}</p>
                                        <Tooltip title="Copy to clipboard">
                                            <IconButton onClick={copyToClipboard} size="small">
                                                <ContentCopyIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </Box>
                                </>
                            ) : (
                                <>
                                    <p>No API Key found.</p>
                                </>
                            )}
                        </>
                    )}
                    {error && <p style={{ color: 'red' }}>{error}</p>}
                </Box>
            </SimpleDialog>
        </>
    );
};

export default ApiKeyManager;
